import { constants, cssVariableStyles } from "@newsela/angelou";
import type { CSSObject } from "@emotion/react";
const {
  colors: { ui },
} = constants;
const { generateIconColorCss } = cssVariableStyles;

export const sectionCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  padding: "45px 0",
  borderTopStyle: "solid",
  borderTopWidth: "1px",
  borderTopColor: ui.core[700],
  breakInside: "avoid",
};

export const titleContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

export const titleCss: CSSObject = {
  color: ui.core[700],
  fontSize: "32px",
  margin: 0,
  lineHeight: "100%",
};

export const subtitleCss: CSSObject = {
  color: ui.neutral[700],
  margin: "0 0 20px 0",
  lineHeight: "100%",
};

export const completedCss: CSSObject = {
  color: ui.green[400],
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontWeight: "bold",
  ...generateIconColorCss({ primaryColor: ui.green[400] }),
  marginBottom: "20px",
};

export const notStartedCss: CSSObject = {
  color: ui.red[400],
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontWeight: "bold",
  ...generateIconColorCss({ primaryColor: ui.red[400] }),
  marginBottom: "20px",
};

export const sectionContentCss: CSSObject = {
  display: "flex",
  "& > div": {
    flex: 1,
    "&:last-child": {
      textAlign: "right",
      paddingRight: "40px",
    },
  },
};

export const cardsCss: CSSObject = {
  display: "grid",
  gap: "16px",
  gridTemplateColumns: "1fr 1fr 1fr",
};

export const cardsForPDFOutputCss: CSSObject = {
  display: "flex",
  gap: 0,
  flexDirection: "column",
  "> div": {
    marginBottom: "16px",
  },
};

export const imageContainerCss: CSSObject = {
  maxWidth: "450px",
  padding: "20px",
};

export const imageCss: CSSObject = {
  width: "100%",
  maxWidth: "450px",
};
